import { BCMSDate } from "@bcm-dev/bcms-vite";
import "./styles.css";
import Week from "../Week";
 // :: bcmsDate,bcmsDate,bcmsDate,bcmsDate -> [WEEKS]
 //Creates a weeks worth of Days adds properties to the days for disabling and labels for fees;
let key =0;
 function getWeek(date,setDate,currentMonth,setHover,inputDate){
    let week = [];  
    let viewDate = date;
    do{
      let newDate =BCMSDate.init(viewDate)
       week.push({newDate,setDate,currentMonth,setHover,inputDate})
        viewDate.offset(1)
       
    }
    while(viewDate.getLongDay !== "Sunday")
    return week;
  }

 // :: bcmsDate,bcmsDate -> [WEEKS]
 //Creates a months worth of weeks as an array to map over 
 function getMonth(viewDate,setDate,setHover,inputDate){
    let newDate = BCMSDate.init(viewDate); 
    let lastDay = BCMSDate.init(viewDate).setToLast();
    let firstDay = BCMSDate.init(newDate.setToFirst());
    do{      
        newDate.offset(-1)
     
    }
    while(newDate.isAfter(firstDay) || newDate.getLongDay   !== "Sunday")
    let month = [];
  
    do{
        
        month.push(getWeek(newDate,setDate,viewDate,setHover,inputDate))       
    }
    while(newDate.isBefore(lastDay))
    return month;
  }
  
export default function Month(props){
    let {setDate,viewDate,onChange,controllers,setHover,inputDate} = props ;
    let month =getMonth(viewDate,setDate,setHover,inputDate);
 
    return(
      <div>        
        <div className="row day-of-the-week-header flex-container flex-horizontal align-center text-center">
            <span className="square flex-width">Sun</span>
            <span className="square flex-width">Mon</span>
            <span className="square flex-width">Tues</span>
            <span className="square flex-width">Wed</span>
            <span className="square flex-width">Thu</span>
            <span className="square flex-width">Fri</span>
            <span className="square flex-width">Sat</span>
        </div>
          {month.map( function(days,index)  {     
           key++;           
            return <div className="row"  key={key.toString()} >  <Week days = {days} onChange={onChange} controllers={controllers}/></div>
          })}
      </div>
      )
  } 